import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-primaryy rounded-0.5xl mb-4 shadow-mainShadow"
}
const _hoisted_2 = { class: "flex justify-start items-center text-lg text-darkText font-bold" }
const _hoisted_3 = { class: "ms-4 text-sm font-normal text-textColor" }
const _hoisted_4 = {
  key: 0,
  class: "absolute end-6 text-textColor text-xs"
}
const _hoisted_5 = {
  key: 0,
  class: "flex justify-between p-8"
}
const _hoisted_6 = { class: "w-4/6 me-8" }
const _hoisted_7 = { class: "ms-2.5 flex justify-start border-s-2 border-dashed border-lighterPurple" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center order-pointer w-5 h-5 rounded-full bg-trackPointerLight relative -start-665" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "w-2.5 h-2.5 rounded-full bg-trackPointer" })
  ])
], -1)
const _hoisted_9 = { class: "w-14 text-sm text-start font-bold text-darkText" }
const _hoisted_10 = { class: "text-start mb-1.5" }
const _hoisted_11 = { class: "text-sm mb-2 text-darkText font-semibold" }
const _hoisted_12 = { class: "ms-2.5 flex justify-start border-s-2 border-dashed border-transparent" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center order-pointer w-5 h-5 rounded-full bg-trackPointerLight relative -start-665" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "w-2.5 h-2.5 rounded-full bg-white" })
  ])
], -1)
const _hoisted_14 = { class: "w-14 text-sm text-start font-bold text-darkText" }
const _hoisted_15 = { class: "text-start mb-1.5" }
const _hoisted_16 = { class: "text-sm mb-2 text-darkText font-semibold" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_18 = { class: "flex justify-start border-s-2 border-dashed border-transparent -ms-1 mt-1.375" }
const _hoisted_19 = { class: "pe-4" }
const _hoisted_20 = { class: "w-25 text-sm font-bold text-darkText" }
const _hoisted_21 = { class: "relative -top-0.5" }
const _hoisted_22 = { class: "ms-2.5 font-bold text-darkText" }
const _hoisted_23 = { class: "text-start mb-1.125" }
const _hoisted_24 = { class: "text-start text-sm mb-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_26 = { class: "flex justify-start border-s-2 border-dashed border-transparent mt-1.375" }
const _hoisted_27 = { class: "flex justify-start pe-4" }
const _hoisted_28 = { class: "text-sm font-bold ms-2 text-darkText" }
const _hoisted_29 = { class: "text-start text-sm font-normal text-darkText mb-1.5" }
const _hoisted_30 = {
  key: 0,
  class: "flex justify-start items-center border-s-2 border-dashed border-transparent mt-1.375"
}
const _hoisted_31 = { class: "flex justify-start pe-4" }
const _hoisted_32 = { class: "text-sm font-bold ms-2 text-darkText" }
const _hoisted_33 = { class: "w-2/6 rotate-2 bg-gray rounded-0.5xl mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_OrdersMap = _resolveComponent("OrdersMap")!

  return (_ctx.order)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.collapsible ? _ctx.toggleCollapse() : null)),
          class: _normalizeClass([{chevron: _ctx.collapsible, 'border-b': _ctx.show, 'border-line': _ctx.show}, "flex cursor-pointer items-center justify-start order-details-top mx-6.5 py-6.5"])
        }, [
          _createElementVNode("p", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.order.orderId) + " ", 1),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.order.orderStatus.value), 1)
          ]),
          (_ctx.collapsible)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.moment(_ctx.order.createdAt).format('hh:mm A')), 1))
            : _createCommentVNode("", true)
        ], 2),
        (!_ctx.collapsible || _ctx.show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('orders.from')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.order.darkStore.name), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('orders.to')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.order.userAddress), 1)
                  ])
                ]),
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("p", _hoisted_20, [
                      _createElementVNode("span", _hoisted_21, [
                        _createVNode(_component_BaseIcon, { name: "clock" })
                      ]),
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('orders.duration')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.order.estimateTime) + " minutes", 1)
                  ])
                ]),
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_BaseIcon, { name: "dollar" }),
                    _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$t('orders.payment')), 1)
                  ]),
                  _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.order.orderTotal), 1)
                ]),
                (_ctx.order.settlementStatus)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t('orders.settlementStatus.title')), 1)
                      ]),
                      _createElementVNode("span", {
                        class: _normalizeClass(["px-2 py-1 text-xs border rounded-md", [
               { 'text-gray-600 bg-gray-200 border-gray-300': _ctx.order?.settlementStatus === 'init'},
               { 'text-orange bg-yellow-100 border-orange': _ctx.order?.settlementStatus === 'requested' },
               { 'text-green-600 bg-green-100 border-green-600': _ctx.order?.settlementStatus === 'approved' },
               { 'text-red-600 bg-red-100 border-red-600': _ctx.order?.settlementStatus === 'rejected' }
            ]])
                      }, _toDisplayString(_ctx.$t(`orders.settlementStatus.${_ctx.order?.settlementStatus ?? '' }`)), 3)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_OrdersMap, {
                  id: 'order-details' + _ctx.order.orderId,
                  class: "z-40",
                  tripDetails: _ctx.tripDetails
                }, null, 8, ["id", "tripDetails"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}